export default ['USA', 'Canada & Guam', 'Caribbean']
